import { Component, inject, input, signal, computed, OnInit } from '@angular/core';
import { ByProductItem, ByProductItemAuditTrailItem } from '@hjc/masterdata-types';
import { ProductsService } from '@services/products.service';
import { InfoComponent, InfoField } from '@components/info/info.component';
import { PageHeaderComponent } from '@components/page-header/page-header.component';
import { AuditTrailComponent } from '@components/audit-trail/audit-trail.component';
import { AuditTrailService } from '@services/audit-trail.service';

@Component({
  selector: 'md-view-byproduct-details',
  imports: [InfoComponent, PageHeaderComponent, AuditTrailComponent],
  templateUrl: './view-byproduct-details.component.html',
  styleUrl: './view-byproduct-details.component.scss',
  standalone: true
})
export class ViewByproductDetailsComponent implements OnInit {
  private productsService = inject(ProductsService);
  private auditTrailService = inject(AuditTrailService);

  byproductItem = signal<ByProductItem | undefined>(undefined);
  auditTrail = signal<ByProductItemAuditTrailItem[]>([]);

  byproductId = input.required<string>();

  // Define field configuration for byproduct info display
  infoFields = computed<InfoField[]>(() => [
    { key: 'id', labelKey: 'FIELDS.CODE', type: 'string' },
    { key: 'name.fi', labelKey: 'FIELDS.DESCRIPTION', type: 'string' },
    { key: 'cat', labelKey: 'FIELDS.CATEGORY', type: 'string' },
    { key: 'createdAt', labelKey: 'FIELDS.SYSTEM.CREATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'createdBy', labelKey: 'FIELDS.SYSTEM.CREATED_BY', type: 'string' },
    { key: 'updatedAt', labelKey: 'FIELDS.SYSTEM.UPDATED_AT', type: 'date', pipe: 'date', dateFormat: 'dd.MM.yyyy HH:mm' },
    { key: 'updatedBy', labelKey: 'FIELDS.SYSTEM.UPDATED_BY', type: 'string' }
  ]);

  ngOnInit(): void {
    const id = this.byproductId();
    if (id) {
      this.loadByproductItem(id);
      this.loadAuditTrail(id);
    }
  }

  private async loadByproductItem(id: string): Promise<void> {
    try {
      const response = await this.productsService.getByProductById(id);
      this.byproductItem.set(response?.data);
    } catch (error) {
      console.error('Error loading slaughterhouse data:', error);
    }
  }

  private async loadAuditTrail(id: string): Promise<void> {
    try {
      const response = await this.auditTrailService.getAuditTrail<ByProductItemAuditTrailItem>('byproduct', id);
      this.auditTrail.set(response?.data || []);
    } catch (error) {
      console.error('Error loading audit trail:', error);
    }
  }
}
